import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import {
  batchTemplateService,
  type BatchTemplate,
} from "@/app/services/generated/batchtemplateService";

// Singleton cache store
const batchTemplatesCacheStore = new EntityCacheStore<BatchTemplate>(
  EnumCacheEntityType.batchTemplate,
  async () => batchTemplateService.getAllBatchTemplates()
);

// Ephemeral reader
export default class BatchTemplatesCache extends EntityWithGuidKeyCache<BatchTemplate> {
  constructor() {
    super(batchTemplatesCacheStore, (x) => x.header.id);
  }
}
